import { render, staticRenderFns } from "./SimpleDashboard.vue?vue&type=template&id=8ebfcd9c"
import script from "./SimpleDashboard.vue?vue&type=script&lang=js"
export * from "./SimpleDashboard.vue?vue&type=script&lang=js"
import style0 from "./SimpleDashboard.vue?vue&type=style&index=0&id=8ebfcd9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports